<template>
  <div class="home">
    <div class="top-bg">
      <video src="@/assets/home-bg-video.mp4" autoplay loop muted ref="video" v-if="!$store.state.isMobile"></video>
      <div class="title">WE BRING THE BEST GAMES TO CHINA.</div>
      <div class="desc">We provide complete guidance and know-how to developers who are looking to publish their games in China and achieve explosive success.</div>
    </div>
    <div class="advantage-wrapper">
      <div class="title">Enabling amazing success since 2007.</div>
      <div class="advantage-list">
        <div class="advantage">
          <img src="@/assets/download.png">
          <div class="head">14 BILLION</div>
          <div class="second">Global downloads.</div>
        </div>
        <div class="advantage">
          <img src="@/assets/market-icon.png">
          <div class="head">410 MILLION</div>
          <div class="second">Monthly users.</div>
        </div>
        <div class="advantage">
          <img src="@/assets/money.png">
          <div class="head">$2.2 BILLION +</div>
          <div class="second">Market cap.</div>
        </div>
        <div class="advantage">
          <img src="@/assets/trophy.png">
          <div class="head">DAU</div>
          <div class="second second-small-font">Up to 20 million on China Android.</div>
        </div>
      </div>
    </div>
    <div class="games-wrapper">
      <div class="title">30 games published & counting.</div>
      <div class="game-list">
        <div 
        v-for="item in data.game"
        :key="item.name"
        class="game"
        >
          <div class="name">{{ item.name }}</div>
          <img :src="item.icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndexData } from '@/api/req'
export default {
  data() {
    return {
      data: {
        game: [],
        banner: []
      },
      windowWidth: document.documentElement.clientWidth,
    }
  },
  activated() {
    if(!this.$store.state.isMobile) {
      this.$refs.video.play()
    }
  },
  mounted() {
    getIndexData().then(res => {
      this.data = res.data.data
    })
    window.onresize = () => {
      return (() => {
        this.windowWidth = document.documentElement.clientWidth
      })()
    }
  },
}
</script>

<style lang="stylus" scoped>
.home
  background #fff

.top-bg
  position relative
  height 632px
  background url('../assets/home-bg.png') no-repeat center top
  background-size cover
  color #fff
  text-align center
  padding-top 228px
  box-sizing border-box

  @media screen and (max-width: 769px)
    padding-top 110px
    height 594px

  .title
    position relative
    font-size 64px
    font-weight 300
    
    @media screen and (max-width: 769px)
      font-size 35px

  .desc
    position relative
    font-size 24px
    max-width 722px
    margin 133px auto 0 auto

    @media screen and (max-width: 769px)
      margin 38px auto 0 auto
      padding 0 30px 

  video 
    position absolute
    left 50%
    top 0
    transform translateX(-50%)

    @media screen and (max-width: 769px)
      display none

.advantage-wrapper
  background #04030C
  padding 120px 0 144px 0

  .title
    color #fff
    font-size 48px
    font-weight 300
    text-align center
    
    @media screen and (max-width: 769px)
      font-size 35px

  .advantage-list
    display flex
    flex-wrap wrap
    justify-content space-around
    margin-top 127px
    max-width 1650px
    margin 127px auto 0 auto

    .advantage
      width 280px
      height 280px
      background url('../assets/advantage-bg.png') no-repeat
      background-size cover
      text-align center

      img 
        width 40px
        height 40px
        margin-top 66.5px

      .head
        font-size 24px
        color #A700FF
        font-weight bold
        margin-top 18.5px

      .second
        font-size 18px
        color #fff
        margin-top 19px

      .second-small-font
        font-size 15px

      .desc
        font-size 18px
        color rgba(255, 255, 255, .8)
        letter-spacing 2px
        margin-top 12px

.games-wrapper
  padding 114px 0 42px 0
  text-align center

  .title
    font-size 48px

    @media screen and (max-width: 769px)
      font-size 35px
    
  .game-list
    display flex
    flex-wrap wrap
    justify-content center
    max-width 1500px
    margin 95px auto 0 auto

    .game
      margin 0 60px 100px 60px

      .name
        font-size 24px

      img
        width 248px
        height 248px
        box-shadow 0px 3px 6px #00000029
        border-radius 22px
        margin-top 20px

</style>
